import GenerateLink from "./generateLink";

export default GenerateLink;
